import { resolveSeniorAppointmentLocation, STUDIO_NAME, STUDIO_STREET_ADDRESS } from './senior-appointment-location';

const orderPackage = (schoolId, school) => ({ schoolId, student: { school } });

describe('resolveSeniorAppointmentLocation', () => {
  it('shows the studio name/address for a studio booking (schoolId 1075), ignoring the home school', () => {
    const op = orderPackage(1075, { name: 'Lincoln High School', seniorLocation: 'Black Box In the Theater' });
    expect(resolveSeniorAppointmentLocation(op)).toEqual({ name: STUDIO_NAME, address: STUDIO_STREET_ADDRESS });
  });

  it('does not repeat the studio name inside the address (would double-print on the two-line senior layout)', () => {
    const op = orderPackage(1075, { name: 'Lincoln High School' });
    const { address } = resolveSeniorAppointmentLocation(op);
    expect(address).not.toContain(STUDIO_NAME);
  });

  it('prefers the school senior_location for a non-studio booking', () => {
    const op = orderPackage(42, { name: 'Lincoln High School', seniorLocation: 'Black Box In the Theater', scheduleLocation: 'Gym' });
    expect(resolveSeniorAppointmentLocation(op)).toEqual({ name: 'Lincoln High School', address: 'Black Box In the Theater' });
  });

  it('falls back to schedule_location when senior_location is blank', () => {
    const op = orderPackage(42, { name: 'Lincoln High School', seniorLocation: '', scheduleLocation: 'Gym' });
    expect(resolveSeniorAppointmentLocation(op)).toEqual({ name: 'Lincoln High School', address: 'Gym' });
  });

  it('returns an empty address when neither location field is set', () => {
    const op = orderPackage(42, { name: 'Lincoln High School' });
    expect(resolveSeniorAppointmentLocation(op)).toEqual({ name: 'Lincoln High School', address: '' });
  });
});
